/**
 * 基础配置
 */
import i18n from '@/utils/i18n'
import { getFetchList, getVisitorAuditState, webTracking, getAuthCode } from '@/api/index'
import { getToken, removeToken } from '@/utils/auth'
import { getType } from '@/utils/function'
import router from '@/router'
import store from '@/store'
import config from '@/config/index'
import { MessageBox } from 'element-ui';

/**
 * 进入登录页面时 记录来源页面的地址 方便登录成功后 跳回来源页面
 * params (Object|String)
 *  Object => {
 *    path: String
 *    source: Boolean
 *    replaceStatus: Boolean
 *  }
 */
export const loginSource = (params = '/login/person') => {
  if (!['string', 'object'].includes(getType(params))) return
  if (params == '') return
  let path
  let source = false
  let replaceStatus = false
  let pathLocation = ''
  let query
  if (getType(params) == 'object') {
    if (!params.path) {
      params.path = '/login/person'
    }
    path = params.path
    source = !!params.source
    replaceStatus = !!params.replaceStatus
    query = params.query || {}
  } else {
    path = params
  }
  pathLocation = path.split('?')
  if (['/login', '/login/actor', '/login/person'].includes(pathLocation)) return
  if (source) {
    window.sessionStorage.setItem('toPath', window.location.pathname)
  }
  if (replaceStatus) {
    router.replace(path)
  } else {
    router.push({ path, query })
  }
}

/**
 * 登录成功后的跳转
 * @param {string}  subjectType 登录者身份 客商，展商
 * @param {boolean} type  true => 邮箱 false => 手机号
 * @param {object}  value question(是否注册流程的问卷页面)/email/phone/secondInfo(是否跳转预登记【完善信息2 + 问卷】)/firstInfo(是否来自完善信息1)
 */
const loginSuccess = async function(subjectType, param = {}, type, value) {
  let info = store.getters.info
  let goHome = function() {
    if (!checkToPath()) return
    router.replace({ path: '/' })
  }

  if (subjectType === 'ACTOR') {
    if (!checkToPath()) {
      return
    }
    /**
     * 展商
     * 登录成功跳转 公司基本信息管理
     */
    let path = param.path ? param.path : '/company-management'
    // 如果不是管理员
    if (!info.exhibitorEmployee.admin) {
      path = '/my-exhibit-list'
    } else {
      // path = '/personal/questionnaire/change'
      path = '/company-management'
    }
    await getFetchList()
      .then(res => {
        return res.data
      })
      .then(res => {
        if (res.data) {
          store.commit('SET_CONFIGSWITCH', res.data.configSwitch)
        }
      })
    router.replace({ path: path })
  } else if (subjectType === 'VISITOR') {
    /**
     * 客商
     * 登录成功跳转 商机管理
     * 客商注册，没有预登记跳转 首页
     * completeExhibitionRegistration true（预登记） false（没有预登记）
     */
    const status = isCompleteExhibitionRegistration()
    if (status) {
      //获取配置项 共登录成功后的页面应用
      await getFetchList()
        .then(async (res) => {
          return res.data
        })
        .then(async (res) => {
          if (res.data) {
            await store.commit('SET_CONFIGSWITCH', res.data.configSwitch)
            if (value && value.question == true) {
              router.replace({ path: '/register/completed' })
              return
            }
            // 完成预登记
            if (!checkToPath()) return
            // 禁止客商操作2 (第二次限制)
            if (config.settings.onlayReg2) {
              router.replace({ path: '/profile' })
              return
            }
            router.replace({ path: param.path ? param.path : '/' })
          }
        })
    } else {
      /**
       * 预登记没有完成
       * info.exhibitionUserCompleteState => 登录返回的状态
       * 不管 judgeLanguageByCountry 根据国家判断客商语言 是否开启，都重新获取配置项
       */
      let state = info.exhibitionUserCompleteState

      /**
       * 是否完成 完善信息1
       * info 为空 => status: undefined
       * 或 state 存在 且 state.completeVisitor 为true
       */
      if (!state || (state && !state.completeVisitor)) {
        //TODO: 暂时解决埋点
        window.PC.$RangersConfigInit({
            info: {
                exhibitionUserCompleteState: {
                    completeExhibitionRegistration: false,
                    completeVisitor: false
                }
            }
        },"change")
        if (type) {
          // 邮箱 完善信息1
          store.commit('SET_LOGIN_ACCOUNT', value.email || '')
          router.push('/l-register/account-email-info/0')
          // gotoEZT3('en')
        } else {
          store.commit('SET_LOGIN_ACCOUNT', value.phone || value.mobile || '')
          // 手机 号完善信息1
          router.push('/l-register/account-mobile-info/0')
          // gotoEZT3('cn')
        }
        return false
      }

      //获取配置项
      await getFetchList()
        .then(async (res) => {
          return res.data
        })
        .then(async (res) => {
          if (res.data) {
            let config = res.data.configSwitch
            await store.commit('SET_CONFIGSWITCH', config)

            /**
             * 判断预登记是否后置
             * 否且不是来自预登记|问卷，直接进入二次完善信息（预登记）
             */
            if (config.visitorDelay && (!value || (value && value.secondInfo !== true))) {
              /**
               * 判断是否来自完善信息1
               * 是，有弹框
               * 否，没有弹框，直接进入首页
               */
              if (!value || (value && value.firstInfo !== true)) {
                goHome()
              } else {
                router.replace({ path: '/' })
                // router.replace({ path: '/register/completed' })
                return
                // this.$alert(this.$t('You have registered, you can visit the online exhibition from June 18 to 24 by using this account'), this.$t('Confirm Registration'), {
                //     confirmButtonText: this.$t('ok'),
                //     showClose:false,
                //     callback: () => {
                //         goHome()
                //     }
                // })
              }

              return false
            }

            // 是否完成 完善信息2
            if (!state.completeVisitorRegister) {
              // 跳转 完善信息2
              router.replace({ path: '/register/account-info/1' })
            } else if (!state.completeQuestionnaire) {
              // 跳转 问卷
              router.replace({ path: '/questionnaire' })
            }
          }
        })
    }
  }
}

function gotoEZT3(languageType = 'cn') {
  // const token = getToken()
  const message = '请选择'

  MessageBox.confirm(message, '提示', {
    type: 'warning',
    cancelButtonText: '回首页',
    confirmButtonText: '完善信息'
  }).then(async () => {
    const authData = await getAuthCode()
    const data = authData.data
    if (data.code === 1000) {
      const authCode = data.data
      // store.commit('SET_EZT_REGISTRATION', true)
      // 正式环境
      const target = `https://regcn.cacshow.com/#/jump?exhibitionId=1960598147339644930&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1965237171072868353&isOpenAdapt=yes&sourceCode=XCXen&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`
      // const target = `https://regcn.cacshow.com/#/jump?exhibitionId=1960598147339644930&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1965237171072868353&isOpenAdapt=yes&sourceCode=XCXen&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`

      window.location.href = target
    }
    
  }).catch(() => {
    // 回首页
    window.location.href = location.origin
  })
}

/**
 * 首次进入 跳转登录页面 登录成功后再次跳转到 之前要进入的页面
 */
const checkToPath = function() {
  var href = window.sessionStorage.getItem('toPath')
  if (href) {
    sessionStorage.removeItem('toPath')
    router.push({ path: href })
    return false
  }
  return true
}

/**
 * 操作限制
 *
 */
function todoPrission() {
  const subjectType = store.getters.subjectType
  const name = store.getters.name
  if (subjectType === 'VISITOR') {
    if (!name) {
      // 客商注册 没有预登记
      window.PC.noUnregisteredDiag(() => {
        toRegistion()
      })
      return false
    }
  }

  return true
}

async function toRegistion() {
  const authData = await getAuthCode()
    const data = authData.data
    if (data.code === 1000) {
      const authCode = data.data
      // store.commit('SET_EZT_REGISTRATION', true)
      // 正式环境
      const languageType = store.getters.language === 'zh' ? 'cn' : 'en'
      // ezt正式环境测试
      const target = `https://regcn.cacshow.com/#/jump?exhibitionId=1960598147339644930&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1965237171072868353&isOpenAdapt=yes&sourceCode=XCXen&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`
      // const target = `http://172.16.1.252:5173/#/jump?exhibitionId=1823536898857046018&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1823539766322335746&isOpenAdapt=yes&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`

      
      
      window.location.href = target
    }
}
// const todoPrission = function() {
//   const subjectType = store.getters.subjectType
//   const info = store.getters.info
//   const status = info && info.exhibitionUserCompleteState ? info.exhibitionUserCompleteState.completeExhibitionRegistration : true
//   if (subjectType === 'VISITOR') {
//     if (!status) {
//       // 客商注册 没有预登记
//       window.PC.noUnregisteredDiag(() => {
//         loginSuccess(subjectType, {}, null, { secondInfo: true })
//       })
//       return false
//     } else if (info.visitor.auditState == 'DISAPPROVE' && info.visitor.languageType == 'cn') {
//       // 国内 完成预登 审核不通过
//       window.PC.noUnregisteredDiag(
//         () => {
//           //loginSuccess(subjectType, {}, null, {secondInfo: true})
//           console.log('DISAPPROVE')
//         },
//         null,
//         'auditTip1',
//         'ok'
//       )
//       return false
//     } else if (info.visitor.auditState == 'PENDING' && info.visitor.languageType == 'cn') {
//       // 国内 完成预登 待审核
//       window.PC.noUnregisteredDiag(
//         () => {
//           // 通过接口判断是否审核通过
//           getVisitorAuditState()
//             .then(res => {
//               return res.data
//             })
//             .then(res => {
//               if (!res.data) return
//               info.visitor.auditState = res.data
//               switch (res.data) {
//                 case 'APPROVE':
//                   // 审核通过
//                   store.dispatch('LogOut').then(() => {
//                     loginSource({replaceStatus: true})
//                   })
//                   break
//                 case 'DISAPPROVE':
//                   // 审核不通过
//                   store.commit('SET_INFO', info)
//                   break
//               }
//             })
//         },
//         null,
//         'auditTip',
//         'ok'
//       )
//       return false
//     }

//     return true
//   } else {
//     return true
//   }
// }

/**
 * 展商/展品/客商详情/直播详情
 * @param {object} data 详情数据
 * @param {string} type 详情类型
 */
const pageDetail = function(data, type, blank=true, moduleName) {
  let id = ''
  switch (type) {
    // 客商
    case 'person':
      id = data.visitorId || data.id
      window.PC.$RangersEventDetail(id, data, 'person', moduleName)
      openNewPage(`/find-person/detail/${id}`, blank)
      break
    // 展品
    case 'product':
      id = data.productId || data.id
      window.PC.$RangersEventDetail(id, data, 'product', moduleName)
      if (data.scope == 1 && data.inPool == false) {
        window.PC.$alter(
          {
            message: i18n.t('common.productTipsContent'),
            title: i18n.t('common.productTipsTitle'),
            confirmButtonText: i18n.t('common.ok')
          },
          () => {
            router.push(`/find-exhibitor/detail/${data.exhibitorId}`)
          }
        )
      } else {
        openNewPage(`/find-exhibit/detail/${id}`, blank)
      }
      break
    case 'self_product':
      id = data.productId || data.id
      openNewPage(`/exhibit-detail/${id}`, blank)
      break
    // 展商
    case 'actor':
      id = data.exhibitorId || data.actorId || data.liveSponsorId || data.url || data.id
      window.PC.$RangersEventDetail(id, data, 'actor', moduleName)
      openNewPage(`/find-exhibitor/detail/${id}`, blank)
      break
    // 直播详情
    case 'live':
      id = data.id || data.liveId
      window.PC.$RangersEventDetail(id, data, 'live', moduleName)
      if (!isLoginStatus()) {
        if (data.scope == 0) {
          openNewPage(`/live/${data.id}`, blank)
        } else {
          isLoginFn()
        }
      } else {
        if (!todoPrission()) return
        openNewPage(`/live/${data.id}`, blank)
      }
      break
  }
}

/**
 * 是否完成预登记
 */
const isCompleteExhibitionRegistration = function(status = false) {
  const info = store.getters.info
  const rStatus = info && info.exhibitionUserCompleteState ? info.exhibitionUserCompleteState.completeExhibitionRegistration : status
  return rStatus
}

/**
 * 判断是否登录, 未登录出现弹框提示
 */
const isLoginFn = function(fn) {
  if (!isLoginStatus()) {
    let s = i18n.t('finds.loginTip')
    let sT = i18n.t('finds.tip')
    window.PC.$alter(
      {
        message: s,
        title: sT,
        confirmButtonText: i18n.t('common.ok')
      },
      () => {
        if (fn) {
          fn()
        } else {
          loginSource()
        }
      }
    )
    return false
  } else {
    return true
  }
}

/**
 * 判断登录状态
 */
const isLoginStatus = function () {
  console.log(getToken())
  console.log(store.getters.subjectType)
  console.log(store.getters.isLogin)
  console.log(store.getters.info)
  console.log(store.getters.info.id)
  return getToken() && store.getters.subjectType 
  && store.getters.isLogin == 1 
  && store.getters.info && store.getters.info.id
}

/**
 * 直播状态
 */
const liveStatusText = function(liveObj) {
  let status = liveObj.liveState
  let text = ''
  if (status == 1) {
    text = i18n.t('live.status["1"]')
  } else if (status == 2) {
    text = i18n.t('live.status["0"]')
  } else {
    text = i18n.t('live.status["2"]')
  }
  return text
}

const openNewPage = function(path, blank=false) {
  let href = ''
  if (path.indexOf("http://") == 0 || path.indexOf("https://") == 0) {
    href = path
  } else {
    href = (router.resolve({
        path: path
    })).href
  }
  if (blank) {
    setTimeout(() => {
        window.open(href, '_blank')
    }, 350)
  } else {
    router.push(path)
  }
}


/**
 * 关闭浏览器当前窗口
 */
const closeBrowserPage = function() {
  window.opener = null
  window.open('', '_self')
  window.close()
}

/**
 * 判断是否是展商
 * 展商 不可操作的行为判断
 * status Boolean 是否判断当前身份 是否展商
 */
const ActorNoTodo = function(status) {
  if (config.settings.noActor) {
    if ((status === true && store.getters.subjectType === 'ACTOR') || !status) {
      store.commit('setNoActorTodo', true)
      return false
    }
  }

  return true
}

const noVisitorTodoAction = () => {
  if (!config.settings.onlayReg) return
  store.commit('setNoVisitorTodo', true)
}

/**
 * 网站埋点 =》注册流程
 * 其他操作的埋点
 * 只有当前身份是非展商时才会埋点
 * @param {Object} behavior 用户行为ID 或者 为用户行为描述对象
 * @param {String | Object} action 行为描述code | 参数
 */
const $tracking = (behavior, action = '001021003') => {
  if (store.getters.subjectType === 'ACTOR') return
  let userId = store.getters.info ? store.getters.info.visitor : ''
  userId = userId ? userId.id : ''
  let params = {
    appKey: 'A00010', // I展通
    type: '000000001', // 客商
    userId: userId || store.getters.loginAccount || '', //用户账号（用户id|邮箱|手机号）
    time: new Date().getTime(),
    site: config.exhibitionId, // 展会ID
    event: '', // 用户行为记录
    prop: {
      terminal: 'PC',   //终端
    }
  }

  if (getType(action) == 'string') {
    params.event = action
  } else if (getType(action) == 'object') {
    params = Object.assign(params, action)
  }

  if (getType(behavior) == 'string' && behavior) {
    params['prop']['behavior'] = behavior
  } else if (behavior) {
    params['prop'] = {
      ...params['prop'],
      ...behavior
    }
  }
  webTracking(params)
}

// 用于主办后台广告位分享统计 (浏览量)
const hostAdvertisingSharingStatistics = function() {
  let pathName = window.location.pathname
  let origin = window.location.origin
  let logsPath = ['/login', '/'] //埋点的地址
  if (pathName === '/login/person') pathName = '/login'
  if (!logsPath.includes(pathName)) return
  let fromUrl = store.getters.fromUrl
  let advertisingSharing = store.getters.advertisingSharing
  let t1 = getType(fromUrl) === 'string' && !!fromUrl
  let t2 = getType(advertisingSharing) === 'string' && !!advertisingSharing
  let t3 = advertisingSharing === (origin + pathName)
  if (pathName === '/login' && store.getters.subjectType !== 'VISITOR') return
  if (t1 && t2 && t3) {
    $tracking({
      source: fromUrl,
      device: navigator.userAgent,
      current: origin + pathName
    }, '001021004')
  }
}

// 用于主办后台广告位分享统计 (预登记完成-注册完成)
const completeVisitorRegisterSharingStatistics = function() {
  let fromUrl = store.getters.fromUrl
  let advertisingSharing = store.getters.advertisingSharing
  let t1 = getType(fromUrl) === 'string' && !!fromUrl
  let t2 = getType(advertisingSharing) === 'string' && !!advertisingSharing
  if (t1 && t2) {
    $tracking({
      source: advertisingSharing + '?fromUrl=' + fromUrl,
      device: navigator.userAgent,
      current: window.location.origin + window.location.pathname
    }, '001021004')
  }
}

// 通过展商邀请函进入 网站统计(浏览量)
const invitationStatistics = function() {
  commonStatistics('001031000', store.getters.invitationSource)
}

/**
 * 埋点
 */
const commonStatistics = function(action, params) {
  if (store.getters.subjectType === 'ACTOR') return
  let info = store.getters.info
  let pop = {}
  let userId = info ? (info.visitor ? info.visitor.email : '') : ''
  switch(action) {
    // 通过展商邀请函进入 网站统计(浏览量)
    case '001031000':
      userId = params.email
      pop = {
        "source": params.exhibitorId,
        "device": "yaoqinghan",
        "current": "yaoqinghan"
      }
      break
    // 客商首页腰部轮播埋点统计
    case '001032000':
      pop = {
        "source": params['coverIcon'],
        "device": "index",
        "current": "indexyaobulunbotu"
      }
      break
    // 客商首页视频播放埋点统计
    case '001033000':
      pop = {
        "source": params['url'],
        "device": "index",
        "current": "indexvideo"
      }
      break
    // 客商首页banner轮播图统计
    case '001034000':
      pop = {
        "source": params['coverIcon'],
        "device": "index",
        "current": "indexshangbulunbotu"
      }
      break
    // 导航菜单 首页
    case '001035001':
      pop = {
        "source": "indexbutton",
        "device": "index",
        "current": "button "
      }
      break
    // 导航菜单 找展商
    case '001035002':
        pop = {
          "source": "indexsearchexhibitor",
          "device": "index",
          "current": "button "
        }
        break
    // 导航菜单 找展品   
    case '001035003':
      pop = {
        "source": "indexsearchproduct",
        "device": "index",
        "current": "button"
      }
      break
    // 导航菜单 3D展馆图
    case '001035004':
      pop = {
        "source": "index3dmap",
        "device": "index",
        "current": "button"
      }
      break
    // 导航菜单 商脉圈
    case '001035005':
      pop = {
        "source": "indexopportunity",
        "device": "index",
        "current": "button"
      }
      break
    // 导航菜单 直播
    case '001035006':
      pop = {
        "source": "indexlive",
        "device": "index",
        "current": "button"
      }
      break
  }
  pop.terminal = 'PC'
  $tracking(pop, {
    'event': action,
    'userId': userId
  })
}

/**
 * 注册流程 过程中返回首页的逻辑
 * */
const registrationBackHome = function(status=true) {
    window.PC.$RangersEventHomeBack()
    const lstatus = isLoginStatus()
    /**
     * 没有登录
     * 或者 登录了且预登记后置
     */
    if (status && (!lstatus || (lstatus && store.getters.config && store.getters.config.visitorDelay === false))) {
        removeToken()
    }
    setTimeout(() => {
        router.replace({ path: '/' })
    }, 100)
}

export default {
  loginSuccess,
  checkToPath,
  todoPrission,
  liveStatusText,
  pageDetail,
  openNewPage,
  closeBrowserPage,
  isCompleteExhibitionRegistration,
  isLoginFn,
  isLoginStatus,
  ActorNoTodo,
  noVisitorTodoAction,
  $tracking,
  hostAdvertisingSharingStatistics,
  completeVisitorRegisterSharingStatistics,
  invitationStatistics,
  commonStatistics,
  loginSource,
  registrationBackHome,
  toRegistion
}
